import React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TButtonsConfig } from './types/TButtons';

const ButtonBase: React.FC<TButtonsConfig> = ({ as = 'button', kind = 'primary', additionalModifiers, ...rest }) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [kind, ...(additionalModifiers ?? [])],
  });

  return <Box {...rest} name="Button" as={as} {...conditionalProps} />;
};

export default React.memo(ButtonBase);
